import * as React from "react";
import Button from "components/form/button";
import { formatMessage } from "lib/globalize-util";
import validators from "lib/validators";
import { merge } from "glamor";
import every from "lodash/every";
import { DATATEST } from "constants/integration";

const RequestAccessButton = ({ model, onRequestOpen }) => {
    const emails = model.contactEmails;
    const styles = merge({
        width: "100%",
        margin: "16px 0 0",
    });

    if (emails.length && every(emails, validators.email)) {
        return (
            <div {...styles}>
                <Button
                    data-test={DATATEST.LOGIN.REQUEST_ACCESS}
                    label={formatMessage("Request Access")}
                    onClick={onRequestOpen}
                    style={{ width: "100%" }}
                />
            </div>
        );
    }
    return null;
};

export { RequestAccessButton };
export default RequestAccessButton;
